import { SERVICE_LABELS } from "../constants";

// Prepare email parameters
const getEmailParams = (formData) => ({
    to_email: 'kiran@topfluxeinc.com, info.topfluxe@gmail.com',
    from_name: formData.name,
    from_email: formData.email,
    phone: formData.phone || 'Not provided',
    company: formData.company || 'Not provided',
    service: SERVICE_LABELS[formData.service],
    description: formData.description || 'Not provided',
    subject: `New Contact Form Submission from ${formData.name}`,
    message: `
        Website Contact Form Submission
        ================================

    Name: ${formData.name}
    Email: ${formData.email}
    Phone: ${formData.phone || 'Not provided'}
    Company: ${formData.company || 'Not provided'}
    Service Interested In: ${SERVICE_LABELS[formData.service]}
    Description: ${formData.description || 'Not provided'}
    This email was sent from the TopFluxe Inc website contact form.
    Please respond to: ${formData.email}

    ---
    Sent from: https://topfluxeinc.com
    Date: ${new Date().toLocaleString()}
        `.trim()
});

export default getEmailParams;